import { BankDealProfile, Industry } from '../models';

export function hasTangibles(profile: BankDealProfile) {
	return (
		profile.assetEquipment ||
		profile.assetUsedEquipment ||
		profile.assetFleetVehicles ||
		profile.assetUsedFleetVehicles ||
		profile.assetMarineVessels ||
		profile.assetUsedMarineVessels ||
		profile.assetHelicopters ||
		profile.usedAssetHelicopters ||
		profile.assetFixedWingAircraft ||
		profile.assetUsedFixedWingAircraft
	);
}

export function hasIntangibles(profile: BankDealProfile) {
	return profile.assetIntellectualProperty || profile.assetRoyalty;
}

export function hasPrograms(profile: BankDealProfile) {
	return (
		profile.sba7aProgram ||
		profile.sba504Program ||
		profile.usdaBusinessProgram ||
		profile.usdaRuralEnergyProgram ||
		profile.usdaCommunityProgram ||
		profile.usda9003Program
	);
}

export function hasSpecialties(industries?: Industry[] | null) {
	if (industries == null) return false;
	return industries.filter(i => i.isSpecialty).length > 0;
}

export function hasExclusions(industries: Industry[] | null) {
	if (industries == null) return false;
	return industries?.filter(i => !i.isSpecialty).length > 0;
}
